<template>
  <thead>
    <tr>
      <th
        v-for="c in USP_MATERIALS_NDS_GRID_COLS"
        :key="c.key"
        class="rso-th"
        :class="c.align === 'left' ? 'rso-th--left' : 'rso-th--right'"
      >
        {{ c.label }}
      </th>
    </tr>
  </thead>
</template>

<script setup>
import { USP_MATERIALS_NDS_GRID_COLS } from "./gridColumns.js";
</script>
